import moment from "moment";

export function getPreviousMonday(date = new Date()) {
  let day = date.getDay();
  let prevMonday = date;
  if (day === 0) {
    prevMonday.setDate(date.getDate() - 6);
  } else if (day === 1) {
    prevMonday.setDate(date.getDate());
  } else {
    prevMonday.setDate(date.getDate() - (day - 1));
  }

  return prevMonday;
}

export function addDays(date = new Date(), days) {
  let day = date;
  day.setDate(day.getDate() + days);
  return day;
}

export function processEvents(events) {
  let eventsData = {};
  events.forEach(i => {
    const key = moment(i.node.startAt).format("M/D/YYYY")
    if (!!eventsData[key]) {
      eventsData = {
        ...eventsData,
        [key]: [
          ...eventsData[key],
          i.node
        ]
      }
    } else {
      eventsData = {
        ...eventsData,
        [key]: new Array(i.node)
      }
    }
  })
  return eventsData;
}
